const DOCS_RESERVED_PATH_PREFIXES = ['/quick-start', '/auth', '/api'] as const

export function isDocsDocumentationPath(pathname: string): boolean {
  if (!pathname || pathname === '/') {
    return false
  }

  return !DOCS_RESERVED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}
